import { Box, Image } from "@chakra-ui/react";
import announcementIcon from "../../../components/AnnouncementModal/image/announment_icon.png";
import useCheckLogin from "../../../hook/useCheckLogin";
import { useNavigate } from "react-router-dom";

const AnnouncementButton = () => {
  const { isMachineUser } = useCheckLogin();

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("?announcement_open=true");
  };

  return (
    <Box
      onClick={handleNavigate}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={`${announcementIcon}`}
        height={{
          base: "30px",
          md: isMachineUser ? "70px" : "50px",
          //xl: "50px",
          xl: isMachineUser ? "70px" : "50px",
        }}
        //minW="50px"
        maxW={{
          base: "30px",
          md: isMachineUser ? "70px" : "50px",
        }}
      />
    </Box>
  );
};

export default AnnouncementButton;
